import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';

import InspectionPanel from './InspectionPanel';
import {BaseCard} from '../../../components/wizard';
import { extendedstyles } from '../../appstyles';

const s:any ={
  root: {
    width: '100%',
    display: 'flex',
    // overflow: 'scroll',
    justifyContent: 'space-between'
  },
  panel: {
    flex: '1 1 auto'
  },
};

class InspectionCard extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.props.deb.log("InspectionCard");
    this.state = {
      next: true,
      idtype: null,
      idfrom: null,
      fwopen: false
    };
  }

  render = () => {
    const { classes, theme, ...extraProps  } = this.props;
    const {record,data,extras,formdata,setItem} = this.props;
    return (
      <BaseCard
        cardid={'INSPECTION'}
        cardname={'Inspection'}
        cardtitle={'Inspection'}
        instruction={'Provide details to create the inspection'}
        step={4}
        buttons={['START','CANCEL','PREV','NEXT','GUIDE']}
        {...extraProps}
      >
        <InspectionPanel 
          data={extraProps.data}
          //record={record} 
          record={{...record,...formdata}}
          extras={extras}
          setItem={setItem}
          />
      </BaseCard>
    );
  }
}

InspectionCard.propTypes = {
  //classes: PropTypes.object.isRequired,
};

export default InspectionCard;
